import { drawing } from '@progress/kendo-drawing';
import { defined } from '../utils/functions.js';
import { VisualBase } from './VisualBase.js';
import { WIDTH, HEIGHT, X, Y } from '../constants.js';
import { sizeOptionsOrDefault, createSegment } from './utils.js';

class Rectangle extends VisualBase {
    constructor(options) {
        super(options);
        this._initPath();
        this._setPosition();
    }
    _setPosition() {
        const options = this.options;
        const x = options.x;
        const y = options.y;
        if (defined(x) || defined(y)) {
            this.position(x || 0, y || 0);
        }
    }
    redraw(options) {
        if (options) {
            super.redraw(options);
            if (this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
                this._drawPath();
            }
            if (this._diffNumericOptions(options, [X, Y])) {
                this._setPosition();
            }
        }
    }
    _initPath() {
        const options = this.options;
        this.drawingElement = new drawing.Path({
            stroke: options.stroke,
            closed: true
        });
        this._fill();
        this._drawPath();
    }
    _drawPath() {
        const drawingElement = this.drawingElement;
        const sizeOptions = sizeOptionsOrDefault(this.options);
        const width = sizeOptions.width;
        const height = sizeOptions.height;
        drawingElement.segments.elements([
            createSegment(0, 0),
            createSegment(width, 0),
            createSegment(width, height),
            createSegment(0, height)
        ]);
    }
}

export { Rectangle };
